import App from '../App/App.js';
import Router from '../App/Router.js';
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import Submenu from "../Navigation/Submenu/Submenu";
import Scroller from "../Scroller/Scroller";
import LangSwitcher from "../Header/LangSwitcher/LangSwitcher";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

const Section = {
    pausedScrolling: false,

    init() {
        this.sections = $('[component="Page"] > section[url]');
        if (!this.sections.length) return;
        // console.log(this.sections);

        this.sections.each((i, el) => {
            this.bind(el)
        })

    },

    bind(el) {
        ScrollTrigger.create({
            id: 'ScrollerSection',
            trigger: el,
            start: "top top+=90",
            end: "bottom top+=90",
            // scrub: true,
            onEnter: (evt) => Section.onEnter($(evt.trigger)),
            // onLeave: (evt) => ScrollerSection.onLeave($(evt.trigger)),
            onEnterBack: (evt) => Section.onEnterBack($(evt.trigger)),
            // onLeaveBack: (evt) => ScrollerSection.onLeaveBack($(evt.trigger)),
            // onRefresh: (evt) => ScrollerSection.onRefresh($(evt.trigger)),
            // markers: true,
        });
    },

    setByUrl() {
        // console.log('----- Section.setByUrl', Router.sectionUrl, this.pausedScrolling, this.sections)
        if (!this.sections || !this.sections.length || this.pausedScrolling) return;
        this.current = this.sections.filter('[url="' + Router.sectionUrl + '"]');
        // console.log('*** current ', this.current)
        if (!this.current.length) return;
        this.scroll();
    },

    scroll() {
        // console.log('----- Section.scroll', this.current)
        gsap.to(window, {
            duration: Scroller.animTime,
            scrollTo: {y: this.current, offsetY: Scroller.yOffset}
        });
    },


    onEnter(section) {
        Submenu.select(section.attr('url'));
    },

    onEnterBack(section) {
        Submenu.select(section.attr('url'));
    },
    //
    // onLeave(section) {
    //     console.log('onLeave ', section)
    //     return undefined;
    // },
    //
    // onLeaveBack(section) {
    //     console.log('onLeaveBack ', section)
    //     return undefined;
    // },
    // onRefresh(section) {
    //     console.log('onRefresh ', section)
    //     return undefined;
    // }

}

export default Section;